export default __webpack_public_path__ + "static/media/welcome-page-2.f395ba40.png";